import { Box, Circle, CircularProgress, Text } from "@chakra-ui/react";
import { ReactComponent as CoursesIcon } from '../../svg/book.svg'
import { ReactComponent as Hourglass } from '../../svg/hourglass.svg'
import { ReactComponent as LiveSession } from '../../svg/signal.svg'
import { ReactComponent as Participants } from '../../svg/group-of-three.svg'
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { loadStatistics } from "../../redux/api_calls/apiCalls";
import { useSelector } from "react-redux";


export default function Statistics() {
    const dispatch = useDispatch()
    const { statisticsData, isLoading } = useSelector(state => state.statisticsState)

    useEffect(() => {
        dispatch(loadStatistics("main"))
         
    }, [])
    return (
        <Box
            w='100%'
            d='flex'
            flexDir='column'
            mb='1.5rem'
        >
            <Text
                fontSize='15px'
                color='#222222'
                fontWeight='800'
                style={{ fontFamily: 'Mulish, sans-serif' }}
                mb='1rem'
            >
                STATISTICS
            </Text>


            <Box
                w='100%'
                d='flex'
                justifyContent='space-between'
                flexWrap='wrap'
                style={{ gap: '0.5rem' }}
            >
                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#FD5F3A1A' mr='1rem'>
                        <CoursesIcon width='25px' height='25px' fill='#fd5f3a' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                           No. of Library Items
                        </Text>
                        {
                            isLoading && statisticsData?.length === 0 ? <CircularProgress size='24px' isIndeterminate color='#000000' /> :
                                <Text
                                    fontSize='24px'
                                    fontWeight='800'
                                    color='#000000'
                                >
                                    {statisticsData[0]?.courses}
                                </Text>
                        }
                    </Box>
                </Box>
                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#3A7DFD1A' mr='1rem'>
                        <Box
                            d='flex'
                            width='24px'
                            height='24px'
                            justifyContent='space-between'
                            alignItems='center'
                            flexWrap='wrap'
                        >
                            <Box
                                width='11px'
                                height='11px'
                                borderRadius='2px'
                                bg='#3A7DFD'
                            ></Box>
                            <Box
                                width='11px'
                                height='11px'
                                borderRadius='2px'
                                bg='#3A7DFD'
                            ></Box>
                            <Box
                                width='11px'
                                height='11px'
                                borderRadius='2px'
                                bg='#3A7DFD'
                            ></Box>
                            <Box
                                width='11px'
                                height='11px'
                                borderRadius='2px'
                                border='1px solid #3A7DFD'
                            ></Box>
                        </Box>
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                             No. of Exam Schedules
                        </Text>
                        {
                            isLoading && statisticsData?.length === 0 ? <CircularProgress size='24px' isIndeterminate color='#000000' /> :
                                <Text
                                    fontSize='24px'
                                    fontWeight='800'
                                    color='#000000'
                                >
                                    {statisticsData[0]?.categories}
                                </Text>
                        }
                    </Box>
                </Box>


                

                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#42C9781A' mr='1rem'>
                        <Hourglass width='25px' height='25px' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                             No. of Schedules
                        </Text>
                        {isLoading && statisticsData?.length === 0 ? <CircularProgress size='24px' isIndeterminate color='#000000' /> :
                            <Text
                                fontSize='24px'
                                fontWeight='800'
                                color='#000000'
                            >
                                {statisticsData[0]?.live_courses}
                            </Text>
                        }
                    </Box>
                </Box>


                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#00DBDB1A' mr='1rem'>
                        <LiveSession width='25px' height='25px' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                             No. of Live Sessions
                        </Text>
                        {
                            isLoading && statisticsData?.length === 0 ? <CircularProgress size='24px' isIndeterminate color='#000000' /> :
                                <Text
                                    fontSize='24px'
                                    fontWeight='800'
                                    color='#000000'
                                >
                                    {statisticsData[0]?.live_sessions}
                                </Text>
                        }
                    </Box>
                </Box>


                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#FFC7001A' mr='1rem'>
                        <Hourglass width='25px' height='25px' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                            No of Holidays
                        </Text>
                        {
                            isLoading && statisticsData?.length === 0 ? <CircularProgress size='24px' isIndeterminate color='#000000' /> :
                                <Text
                                    fontSize='24px'
                                    fontWeight='800'
                                    color='#000000'
                                >
                                    {statisticsData[0]?.live_users}
                                </Text>
                        }
                    </Box>
                </Box>


                <Box
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    w='32%'
                    bg='#ffffff'
                    d='flex'
                    justifyContent='flex-start'
                    alignItems='center'
                    py='1.5rem'
                    pl='1rem'
                >
                    <Circle size='70px' bg='#A34DE51A' mr='1rem'>
                        <Participants width='25px' height='25px' />
                    </Circle>
                    <Box
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        <Text
                            color='#00000080'
                            fontSize='15px'
                            fontWeight='700'
                        >
                             No. of Participants
                        </Text>
                        {
                            isLoading && statisticsData?.length === 0 ? <CircularProgress size='24px' isIndeterminate color='#000000' /> :
                                <Text
                                    fontSize='24px'
                                    fontWeight='800'
                                    color='#000000'
                                >
                                    {statisticsData[0]?.participants}
                                </Text>
                        }
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}